export const makeTour = (tour) => {
  tour.detailResponses.map(item => {
    item.travelGroupId = item.prices[0].groupId
    item.prices = [...item.prices.map((item, index) => {
      item.selected = index === 0
      return item
    })]
  })
  return tour
}

export const makeEmptyTourFilter = () => {
  return {
    prezzo: null,
    nome: null
  }
}



// WEBPACK FOOTER //
// ./src/front/store/modules/itinerario/actions/tour.js